import { call, delay, put, takeEvery, takeLatest } from "redux-saga/effects";
import axiosApi from "../../utils/axios";
import {
  requestTimePeriod,
  successTimePeriod,
  failureTimePeriod,
  updateTimePeriodRequest,
  updateTimePeriodSuccess,
  updateTimePeriodFailure,
  requestArtifactPeriod,
  successArtifactPeriod,
  failureArtifactPeriod,
  updateArtifactPeriodRequest,
  updateArtifactPeriodSuccess,
  updateArtifactPeriodFailure,
  requestGetMailingConfigs,
  successGetMailingConfigs,
  failureGetMailingConfigs,
  requestSetMailingConfigs,
  successSetMailingConfigs,
  failureSetMailingConfigs,
  requestResetMailingConfigs,
  successResetMailingConfigs,
  failureResetMailingConfigs,
  requestSetMaliciousSubmissionMailContent,
  requestResetMaliciousSubmissionMailContent,
  successSetMaliciousSubmissionMailContent,
  failureSetMaliciousSubmissionMailContent,
  failureResetMaliciousSubmissionMailContent,
  successResetMaliciousSubmissionMailContent,
  requestGetMaliciousSubmissionMailContent,
  successGetMaliciousSubmissionMailContent,
  dumpDatabaseRequest,
  requestDumpStatus,
  updateDumpStatus,
  requestRestoreStatus,
  updateRestoreStatus,
  requestUpdateMailingActive,
  successUpdateMailingActive,
  failureUpdateMailingActive,
  requestGetSyslogConfig,
  requestSetSyslogConfig,
  successSetSyslogConfig,
  failureSetSyslogConfig,
  successGetSyslogConfig,
  failureGetSyslogConfig,
  successDeleteSyslogConfig,
  failureDeleteSyslogConfig,
  requestDeleteSyslogConfig,
  requestGetMailRecipients,
  requestAddMailRecipients,
  requestDeleteMailRecipients,
  successGetMailRecipients,
  failureGetMailRecipients,
  successAddMailRecipients,
  failureAddMailRecipients,
  successDeleteMailRecipients,
  failureDeleteMailRecipients,
  requestSetTelegramConfig,
  successSetTelegramConfig,
  failureSetTelegramConfig,
  requestGetTelegramConfig,
  successGetTelegramConfig,
  failureGetTelegramConfig,
  requestSetSlackConfig,
  successSetSlackConfig,
  failureSetSlackConfig,
  requestGetSlackConfig,
  successGetSlackConfig,
  failureGetSlackConfig,
  RequestCustomSignatureUpload,
  SuccessCustomSignatureUpload,
  FailureCustomSignatureUpload,
  SetCustomSignatureFile,
  RequestCustomSignatures,
  SuccessCustomSignatures,
  FailureCustomSignatures,
  RequestDeleteCustomSignature,
  SuccessDeleteCustomSignature,
  FailureDeleteCustomSignature,
  RequestEditCustomSignature,
  SuccessEditCustomSignature,
  FailureEditCustomSignature,
  RequestGetHostname,
  SuccessGetHostname,
  FailureGetHostname,
  RequestSetHostname,
  SuccessSetHostname,
  FailureSetHostname,
  RequestUniqueId,
  SuccessUniqueId,
  FailureUniqueId,
  RequestTestSyslogServer,
  SuccessTestSyslogServer,
  FailureTestSyslogServer,
  RequestGetPrtgConfigs,
  SuccessGetPrtgConfigs,
  FailureGetPrtgConfigs,
  RequestSetPrtgConfigs,
  SuccessSetPrtgConfigs,
  FailureSetPrtgConfigs,
  RequestGetUpdateSchedulerConfigs,
  SuccessGetUpdateSchedulerConfigs,
  FailureGetUpdateSchedulerConfigs,
  RequestSetUpdateSchedulerConfigs,
  SuccessSetUpdateSchedulerConfigs,
  FailureSetUpdateSchedulerConfigs,
  RequestGetLdapStatus,
  SuccessGetLdapStatus,
  FailureGetLdapStatus,
  RequestGetLdapConfigs,
  SuccessGetLdapConfigs,
  FailureGetLdapConfigs,
  RequestSetLdapConfigs,
  SuccessSetLdapConfigs,
  FailureSetLdapConfigs,
  RequestToggleLdapStatus,
  RequestGetLlmSettings,
  SuccessGetLlmSettings,
  FailureGetLlmSettings,
  RequestSetLlmSettings,
  SuccessSetLlmSettings,
  FailureSetLlmSettings,
  RequestTestLlmSettings,
  SuccessTestLlmSettings,
  FailureTestLlmSettings,
  RequestToggleLlmSettings,
  SuccessToggleLlmSettings,
  FailureToggleLlmSettings,
  RequestCoreServers,
  SuccessCoreServers,
  FailureCoreServers,
  RequestUpdateCoreServers,
  SuccessUpdateCoreServers,
  FailureUpdateCoreServers,
  requestGetAutoSubmissionSettings,
  successGetAutoSubmissionSettings,
  failureGetAutoSubmissionSettings,
  requestSetAutoSubmissionSettings,
  successSetAutoSubmissionSettings,
  failureSetAutoSubmissionSettings,
  requestResetAutoSubmissionSettings,
} from "../actions/settingsActions";
import { RequestBackendServiceConnected } from "../actions/containerActions";
import { addNotification } from "../actions/notifierActions";
import { customFormData } from "../../utils/customFormData";

export function* timePeriod() {
  try {
    const response = yield call(axiosApi.get, "/api/settings/dataRetention/timePeriod");
    yield put(successTimePeriod(response?.data));
  } catch (error) {
    yield put(failureTimePeriod(error));
  }
}

export function* updateTimePeriod({ payload: data }) {
  const formData = customFormData(data);
  try {
    const response = yield call(axiosApi.put, "/api/settings/dataRetention/timePeriod", formData);
    yield put(updateTimePeriodSuccess(Number(response?.data?.updated_time_period)));
    yield put(addNotification({ message: response.data.message, options: { variant: "success" } }));
  } catch (error) {
    yield put(updateTimePeriodFailure(error));
    yield put(addNotification({ message: "Error", options: { variant: "error" } }));
  }
}

export function* artifactPeriod() {
  try {
    const response = yield call(axiosApi.get, "/api/settings/dataRetention/artifactPeriod");
    yield put(successArtifactPeriod(Number(response?.data)));
  } catch (error) {
    yield put(failureArtifactPeriod(error));
  }
}

export function* updateArtifactPeriod({ payload: data }) {
  const formData = customFormData(data);
  try {
    const response = yield call(
      axiosApi.put,
      "/api/settings/dataRetention/artifactPeriod",
      formData,
    );
    yield put(updateArtifactPeriodSuccess(Number(response?.data?.updated_artifact_period)));
    yield put(addNotification({ message: response.data.message, options: { variant: "success" } }));
  } catch (error) {
    yield put(updateArtifactPeriodFailure(error));
    yield put(
      addNotification({
        message: error?.response?.data?.message || "Error",
        options: { variant: "error" },
      }),
    );
  }
}

export function* getMailingConfigs() {
  try {
    const response = yield axiosApi.get("/api/settings/mailing");
    yield put(successGetMailingConfigs(response.data));
  } catch (error) {
    yield put(failureGetMailingConfigs(error));
  }
}

export function* setMailingConfigs({ payload: data }) {
  const formData = customFormData(data.server);
  formData.append("server", data.server);
  formData.append("sender_email", data.senderEmail);
  formData.append("sender_password", data.senderPassword);
  formData.append("port", data.port);
  formData.append("security", data.security);

  try {
    const response = yield axiosApi.post("/api/settings/mailing", formData);

    yield put(successSetMailingConfigs(response.data));
    yield put(
      addNotification({ message: "Changed your mailing configs", options: { variant: "success" } }),
    );
  } catch (error) {
    yield put(
      addNotification({ message: error.response.data.message, options: { variant: "error" } }),
    );

    yield put(failureSetMailingConfigs(error));
  }
}

export function* resetMailingConfigs() {
  const formData = customFormData({ reset: true });
  formData.append("reset", "true");

  try {
    const response = yield axiosApi.put("/api/settings/mailing", formData);

    yield put(successResetMailingConfigs(response.data));
    yield put(
      addNotification({ message: "Reset your mailing configs", options: { variant: "success" } }),
    );
  } catch (error) {
    yield put(failureResetMailingConfigs(error));
  }
}

export function* getMailRecipients() {
  try {
    const response = yield axiosApi.get("/api/settings/mailing/recipients");

    yield put(successGetMailRecipients(response.data));
  } catch (error) {
    yield put(failureGetMailRecipients(error));
  }
}

export function* addMailRecipients({ payload: data }) {
  const formData = customFormData(data.recipient);
  formData.append("recipient", data.recipient);

  try {
    const response = yield axiosApi.post("/api/settings/mailing/recipients", formData);

    yield put(successAddMailRecipients(response.data));
    yield put(
      addNotification({
        message: "Successfully added the recipient",
        options: { variant: "success" },
      }),
    );
  } catch (error) {
    yield put(
      addNotification({
        message: "Adding the recipient failed",
        options: { variant: "error" },
      }),
    );

    yield put(failureAddMailRecipients(error));
  }
}

export function* deleteMailRecipients({ payload: data }) {
  const formData = customFormData(data.recipient);
  formData.append("recipient", data.recipient);

  try {
    const response = yield axiosApi.delete("/api/settings/mailing/recipients", { data: formData });

    yield put(successDeleteMailRecipients(response.data));
    yield put(
      addNotification({
        message: "Successfully deleted the recipient",
        options: { variant: "success" },
      }),
    );
  } catch (error) {
    console.log(error);
    yield put(
      addNotification({
        message: "Deleting the recipient failed",
        options: { variant: "error" },
      }),
    );

    yield put(failureDeleteMailRecipients(error));
  }
}

export function* updateMailingActive({ payload: data }) {
  const formData = customFormData({});

  if (data.active) {
    formData.append("active", "True");
  } else {
    formData.append("active", "False");
  }

  try {
    const response = yield axiosApi.put("/api/settings/mailing/active", formData);

    yield put(successUpdateMailingActive(response.data));
  } catch (error) {
    yield put(failureUpdateMailingActive(error));
  }
}

export function* getMaliciousSubmissionMailContent() {
  try {
    const response = yield axiosApi.get("/api/settings/mailing/mailContent");

    yield put(successGetMaliciousSubmissionMailContent(response.data));
  } catch (error) {
    yield put(failureResetMaliciousSubmissionMailContent(error));
  }
}

export function* resetMaliciousSubmissionMailContent() {
  try {
    const response = yield axiosApi.put("/api/settings/mailing/mailContent");

    yield put(successResetMaliciousSubmissionMailContent(response.data));
    yield put(
      addNotification({ message: "Reset your mailing configs", options: { variant: "success" } }),
    );
  } catch (error) {
    yield put(failureResetMaliciousSubmissionMailContent(error));
  }
}

export function* setMaliciousSubmissionMailContent({ payload: data }) {
  const formData = customFormData(data.subject);
  formData.append("subject", data.subject);
  formData.append("body", data.body);

  try {
    const response = yield axiosApi.post("/api/settings/mailing/mailContent", formData);

    yield put(successSetMaliciousSubmissionMailContent(response.data));
    yield put(
      addNotification({
        message: "Changed your malicious submission notification settings",
        options: { variant: "success" },
      }),
    );
  } catch (error) {
    yield put(failureSetMaliciousSubmissionMailContent(error));
  }
}

export function* dumpDatabase() {
  try {
    // Running/reporting UI submissions are cleared by the backend once the backup is started
    const response = yield call(axiosApi.post, "/api/settings/dump");
    yield put(addNotification({ message: response.data.message, options: { variant: "success" } }));
    yield call(dumpStatus);
  } catch (error) {
    yield put(
      addNotification({
        message: error?.response?.data?.message ?? "Starting backup failed",
        options: { variant: "error" },
      }),
    );
  }
}

export function* dumpStatus() {
  try {
    const response = yield call(axiosApi.get, "/api/settings/dump/status");
    yield put(updateDumpStatus(response.data));
  } catch (error) {
    yield put(
      addNotification({
        message: error?.response?.data?.message ?? "Getting backup status failed",
        options: { variant: "error" },
      }),
    );
  }
}

export function* restoreStatus() {
  try {
    const response = yield call(axiosApi.get, "/api/settings/restore/status");
    yield put(updateRestoreStatus(response.data));
  } catch (error) {
    yield put(
      addNotification({
        message: error?.response?.data?.message ?? "Getting restore status failed",
        options: { variant: "error" },
      }),
    );
  }
}

export function* getSyslogConfig() {
  try {
    const response = yield axiosApi.get("/api/settings/syslog/config");
    yield put(successGetSyslogConfig(response.data));
  } catch (error) {
    yield put(failureGetSyslogConfig(error));
    yield put(
      addNotification({
        message: "Getting syslog configurations failed",
        options: { variant: "error" },
      }),
    );
  }
}

export function* setSyslogConfig({ payload: data }) {
  try {
    yield call(axiosApi.post, "/api/settings/syslog/config", data);
    yield put(successSetSyslogConfig());
    yield put(
      addNotification({
        message: "Changed your syslog configurations",
        options: { variant: "success" },
      }),
    );
    yield call(getSyslogConfig);
  } catch (error) {
    yield put(failureSetSyslogConfig(error));
    yield put(
      addNotification({ message: error.response.data.message, options: { variant: "error" } }),
    );
  }
}

export function* deleteSyslogConfig() {
  try {
    yield axiosApi.delete("/api/settings/syslog/config");
    yield put(successDeleteSyslogConfig());
    yield call(getSyslogConfig);
  } catch (error) {
    yield put(failureDeleteSyslogConfig(error));
    yield put(
      addNotification({
        message: "Deleting syslog configurations failed",
        options: { variant: "error" },
      }),
    );
  }
}

export function* setTelegramConfig({ payload: cid }) {
  try {
    const response = yield axiosApi.get(`/api/settings/settelegramnotification/${cid}`);

    yield put(successSetTelegramConfig(response.data));
    yield put(
      addNotification({
        message: "Updated telegram config successfully",
        options: { variant: "success" },
      }),
    );
  } catch (error) {
    yield put(failureSetTelegramConfig(error));
    yield put(
      addNotification({
        message: "Updating telegram config failed",
        options: { variant: "error" },
      }),
    );
  }
}

export function* getTelegramConfig() {
  try {
    const response = yield axiosApi.get(`/api/settings/gettelegramnotification`);

    yield put(successGetTelegramConfig(response.data));
  } catch (error) {
    yield put(failureGetTelegramConfig(error));
  }
}

export function* setSlackConfig({ payload: data }) {
  try {
    const response = yield call(axiosApi.post, "/api/settings/setslacknotification", data);

    yield put(successSetSlackConfig(response.data));
    yield put(
      addNotification({
        message: "Updated slack config successfully",
        options: { variant: "success" },
      }),
    );
  } catch (error) {
    yield put(failureSetSlackConfig(error));
    yield put(
      addNotification({
        message: "Updating slack config failed",
        options: { variant: "error" },
      }),
    );
  }
}

export function* getSlackConfig() {
  try {
    const response = yield axiosApi.get(`/api/settings/getslacknotification`);

    yield put(successGetSlackConfig(response.data));
  } catch (error) {
    yield put(failureGetSlackConfig(error));
  }
}

export function* customSignatureUpload({ payload }) {
  const { file, signatureType } = payload;
  try {
    const formData = customFormData({});
    formData.append("file", file);
    yield call(axiosApi.post, `/api/settings/custom-signatures/${signatureType}`, formData);
    yield put(SuccessCustomSignatureUpload());
    yield put(
      addNotification({
        message: "Uploaded custom signature successfully",
        options: { variant: "success" },
      }),
    );
    yield put(SetCustomSignatureFile(null));
    yield call(customSignatures, { payload: signatureType });
  } catch (e) {
    yield put(FailureCustomSignatureUpload());
    yield put(
      addNotification({
        message: "Uploading custom signature failed",
        options: { variant: "error" },
      }),
    );
  }
}

export function* customSignatures({ payload: signatureType }) {
  try {
    const response = yield call(axiosApi.get, `/api/settings/custom-signatures/${signatureType}`);
    yield put(SuccessCustomSignatures(response.data));
  } catch (e) {
    yield put(FailureCustomSignatures());
  }
}

export function* deleteCustomSignature({ payload }) {
  const { customSignatureId, signatureType } = payload;
  try {
    yield call(
      axiosApi.delete,
      `/api/settings/custom-signatures/${signatureType}/${customSignatureId}`,
    );
    yield put(SuccessDeleteCustomSignature());
    yield put(
      addNotification({
        message: "Deleted custom signature successfully",
        options: { variant: "success" },
      }),
    );
    yield call(customSignatures, { payload: signatureType });
  } catch (e) {
    yield put(FailureDeleteCustomSignature());
    yield put(
      addNotification({
        message: "Deleting custom signature failed",
        options: { variant: "error" },
      }),
    );
  }
}

export function* editCustomSignature({ payload }) {
  const { customSignatureId, signatureType } = payload;
  try {
    yield call(
      axiosApi.put,
      `/api/settings/custom-signatures/${signatureType}/${customSignatureId}`,
    );
    yield put(SuccessEditCustomSignature());
    yield put(
      addNotification({
        message: "Edited custom signature successfully",
        options: { variant: "success" },
      }),
    );
    yield call(customSignatures, { payload: signatureType });
  } catch (e) {
    yield put(FailureEditCustomSignature());
    yield put(
      addNotification({
        message: "Editing custom signature failed",
        options: { variant: "error" },
      }),
    );
  }
}

export function* getHostname() {
  try {
    const response = yield call(axiosApi.get, "/api/settings/hostname");
    yield put(SuccessGetHostname(response.data));
  } catch (e) {
    yield put(FailureGetHostname());
    yield put(
      addNotification({
        message: "Getting hostname failed",
        options: { variant: "error" },
      }),
    );
  }
}

export function* setHostname({ payload: hostname }) {
  try {
    yield call(axiosApi.post, "/api/settings/hostname", { hostname });
    yield put(SuccessSetHostname());
    yield call(getHostname);
    yield put(
      addNotification({
        message: "Saved hostname sucessfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureSetHostname());
    yield put(
      addNotification({
        message: "Saving hostname failed",
        options: { variant: "error" },
      }),
    );
  }
}

export function* uniqueId() {
  try {
    const response = yield call(axiosApi.get, "/api/settings/unique-id");
    yield put(SuccessUniqueId(response.data));
  } catch (e) {
    yield put(FailureUniqueId());
  }
}

export function* testSyslogServer() {
  try {
    const response = yield call(axiosApi.post, "/api/settings/api/syslog/test-log");
    yield put(SuccessTestSyslogServer(response.data.message || ""));
    yield put(
      addNotification({
        message: "Test log was sent successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureTestSyslogServer());
    yield put(
      addNotification({
        message: "Sending test log failed",
        options: { variant: "error" },
      }),
    );
  }
}

export function* getPrtgConfigs() {
  try {
    const response = yield call(axiosApi.get, "/api/settings/prtg");
    yield put(SuccessGetPrtgConfigs(response.data));
  } catch (e) {
    yield put(FailureGetPrtgConfigs());
    yield put(
      addNotification({
        message: "Getting prtg configs failed",
        options: { variant: "error" },
      }),
    );
  }
}

export function* setPrtgConfigs({ payload: reqBody }) {
  try {
    yield call(axiosApi.put, "/api/settings/prtg", reqBody);
    yield put(SuccessSetPrtgConfigs());
    yield put(
      addNotification({
        message: "Updated prtg configs successfully",
        options: { variant: "success" },
      }),
    );
    yield call(getPrtgConfigs);
  } catch (e) {
    yield put(FailureSetPrtgConfigs());
    if (e.response.data.message === "Testing prtg failed") {
      yield put(
        addNotification({
          message: "Connection failed - please check the ip/domain, port, or token information.",
          options: { variant: "error" },
        }),
      );
    } else {
      yield put(
        addNotification({
          message: "Updating prtg configs failed",
          options: { variant: "error" },
        }),
      );
    }
  }
}

export function* getUpdateSchedulerConfigs() {
  try {
    const response = yield call(axiosApi.get, "/api/settings/update-scheduler");
    yield put(SuccessGetUpdateSchedulerConfigs(response.data));
  } catch (e) {
    yield put(FailureGetUpdateSchedulerConfigs());
    yield put(
      addNotification({
        message: "Getting update scheduler configs failed",
        options: { variant: "error" },
      }),
    );
  }
}

export function* setUpdateSchedulerConfigs({ payload: reqBody }) {
  try {
    yield call(axiosApi.put, "/api/settings/update-scheduler", reqBody);
    yield put(SuccessSetUpdateSchedulerConfigs());
    yield call(getUpdateSchedulerConfigs);
  } catch (e) {
    yield put(FailureSetUpdateSchedulerConfigs());
    yield put(
      addNotification({
        message: "Updating scheduler configs failed",
        options: { variant: "error" },
      }),
    );
  }
}

export function* getLdapStatus() {
  try {
    const response = yield call(axiosApi.get, "/api/settings/ldap-status");
    yield put(SuccessGetLdapStatus(response.data));
  } catch (e) {
    yield put(FailureGetLdapStatus());
  }
}

export function* getLdapConfigs() {
  try {
    const response = yield call(axiosApi.get, "/api/settings/ldap-settings");
    yield put(SuccessGetLdapConfigs(response.data));
  } catch (e) {
    yield put(FailureGetLdapConfigs());
    // Don't show error notification for LDAP configs - it's optional
    // console.log("LDAP configs not available:", e.message);
  }
}

export function* setLdapConfigs({ payload: reqBody }) {
  try {
    yield call(axiosApi.post, "/api/settings/ldap-settings", reqBody);
    yield put(SuccessSetLdapConfigs());
    yield call(getLdapConfigs);
    yield put(
      addNotification({
        message: "LDAP settings saved successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureSetLdapConfigs());
    const detail = e?.response?.data?.message;
    yield put(
      addNotification({
        message: detail || "Updating LDAP configs failed",
        options: { variant: "error" },
        time: detail ? 9000 : 4000,
      }),
    );
  }
}

export function* toggleLdapStatus({ payload: { active } }) {
  try {
    yield call(axiosApi.post, "/api/settings/ldap-toggle", { active });
    yield call(getLdapConfigs);
    yield put(
      addNotification({
        message: active ? "LDAP activated successfully" : "LDAP deactivated successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(
      addNotification({
        message: "Failed to toggle LDAP status",
        options: { variant: "error" },
      }),
    );
  }
}

export function* getLlmSettings() {
  try {
    const response = yield call(axiosApi.get, "/api/settings/llm-settings");
    yield put(SuccessGetLlmSettings(response.data));
  } catch (e) {
    yield put(FailureGetLlmSettings());
    yield put(
      addNotification({
        message: "Getting LLM settings failed",
        options: { variant: "error" },
      }),
    );
  }
}

export function* setLlmSettings({ payload: reqBody }) {
  try {
    const response = yield call(axiosApi.post, "/api/settings/llm-settings", reqBody);
    yield put(SuccessSetLlmSettings());
    yield call(getLlmSettings);
    yield put(
      addNotification({
        message: response?.data?.message || "LLM settings saved successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureSetLlmSettings());
    const detail = e?.response?.data?.message;
    yield put(
      addNotification({
        message: detail || "Updating LLM settings failed",
        options: { variant: "error" },
        time: detail ? 9000 : 4000,
      }),
    );
  }
}

export function* testLlmSettings({ payload: reqBody }) {
  try {
    const response = yield call(axiosApi.post, "/api/settings/llm-test", reqBody);
    yield put(SuccessTestLlmSettings(response.data));
  } catch (e) {
    yield put(
      FailureTestLlmSettings({
        success: false,
        message: e?.response?.data?.message || "Testing LLM connection failed",
      }),
    );
  }
}

export function* toggleLlmSettings({ payload: { active } }) {
  try {
    const response = yield call(axiosApi.post, "/api/settings/llm-toggle", { active });
    yield put(SuccessToggleLlmSettings());
    yield call(getLlmSettings);
    yield put(
      addNotification({
        message: response?.data?.message || "LLM disabled",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureToggleLlmSettings());
    yield put(
      addNotification({
        message: e?.response?.data?.message || "Failed to change LLM status",
        options: { variant: "error" },
      }),
    );
  }
}

export function* coreServers() {
  try {
    const response = yield call(axiosApi.get, "/api/settings/core-servers");
    yield put(SuccessCoreServers(response.data));
  } catch (e) {
    yield put(FailureCoreServers());
    yield put(
      addNotification({
        message: "Failed to get core servers",
        options: { variant: "error" },
      }),
    );
  }
}

export function* updateCoreServers({ payload: updatedList }) {
  try {
    yield call(axiosApi.put, "/api/settings/core-servers", {
      updated_list: updatedList,
    });
    yield put(SuccessUpdateCoreServers());
    yield put(
      addNotification({
        message: "Updated core servers successfully",
        options: { variant: "success" },
      }),
    );
    yield delay(3000);
    yield put(RequestBackendServiceConnected());
  } catch (e) {
    yield put(FailureUpdateCoreServers());
    yield put(
      addNotification({
        message: "Failed to update core servers",
        options: { variant: "error" },
      }),
    );
  }
}

export function* getAutoSubmissionSettings({ payload: submitType }) {
  try {
    const response = yield call(axiosApi.get, `/api/settings/auto-submission/${submitType}`);
    yield put(
      successGetAutoSubmissionSettings({
        submitType,
        settings: response.data.settings,
      }),
    );
  } catch (e) {
    yield put(failureGetAutoSubmissionSettings());
    yield put(
      addNotification({
        message: "Getting auto submission settings failed",
        options: { variant: "error" },
      }),
    );
  }
}

export function* setAutoSubmissionSettings({ payload: { submitType, settings } }) {
  try {
    const response = yield call(axiosApi.put, `/api/settings/auto-submission/${submitType}`, {
      settings,
    });
    yield put(
      successSetAutoSubmissionSettings({
        submitType,
        settings: response.data.settings,
      }),
    );
    yield put(
      addNotification({
        message: "Saved auto submission settings successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(failureSetAutoSubmissionSettings());
    yield put(
      addNotification({
        // the backend owns the "1 to 2 active machines" rule, so show what it reports
        message: e?.response?.data?.message || "Saving auto submission settings failed",
        options: { variant: "error" },
      }),
    );
  }
}

export function* resetAutoSubmissionSettings({ payload: submitType }) {
  try {
    const response = yield call(axiosApi.delete, `/api/settings/auto-submission/${submitType}`);
    yield put(
      successSetAutoSubmissionSettings({
        submitType,
        settings: response.data.settings,
      }),
    );
    yield put(
      addNotification({
        message: "Reset auto submission settings to defaults",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(failureSetAutoSubmissionSettings());
    yield put(
      addNotification({
        message: "Resetting auto submission settings failed",
        options: { variant: "error" },
      }),
    );
  }
}

const settingsSagas = [
  takeEvery(requestTimePeriod, timePeriod),
  takeEvery(updateTimePeriodRequest, updateTimePeriod),
  takeEvery(requestArtifactPeriod, artifactPeriod),
  takeEvery(updateArtifactPeriodRequest, updateArtifactPeriod),
  takeEvery(requestGetMailingConfigs, getMailingConfigs),
  takeEvery(requestSetMailingConfigs, setMailingConfigs),
  takeEvery(requestResetMailingConfigs, resetMailingConfigs),
  takeEvery(requestGetMailRecipients, getMailRecipients),
  takeEvery(requestAddMailRecipients, addMailRecipients),
  takeEvery(requestDeleteMailRecipients, deleteMailRecipients),
  takeEvery(requestUpdateMailingActive, updateMailingActive),
  takeEvery(requestGetMaliciousSubmissionMailContent, getMaliciousSubmissionMailContent),
  takeEvery(requestSetMaliciousSubmissionMailContent, setMaliciousSubmissionMailContent),
  takeEvery(requestResetMaliciousSubmissionMailContent, resetMaliciousSubmissionMailContent),
  takeEvery(dumpDatabaseRequest, dumpDatabase),
  takeEvery(requestDumpStatus, dumpStatus),
  takeEvery(requestRestoreStatus, restoreStatus),
  takeEvery(requestGetSyslogConfig, getSyslogConfig),
  takeEvery(requestSetSyslogConfig, setSyslogConfig),
  takeEvery(requestDeleteSyslogConfig, deleteSyslogConfig),
  takeEvery(requestSetTelegramConfig, setTelegramConfig),
  takeEvery(requestGetTelegramConfig, getTelegramConfig),
  takeEvery(requestSetSlackConfig, setSlackConfig),
  takeEvery(requestGetSlackConfig, getSlackConfig),
  takeLatest(RequestCustomSignatureUpload, customSignatureUpload),
  takeLatest(RequestCustomSignatures, customSignatures),
  takeLatest(RequestDeleteCustomSignature, deleteCustomSignature),
  takeLatest(RequestEditCustomSignature, editCustomSignature),
  takeLatest(RequestGetHostname, getHostname),
  takeLatest(RequestSetHostname, setHostname),
  takeLatest(RequestUniqueId, uniqueId),
  takeLatest(RequestTestSyslogServer, testSyslogServer),
  takeLatest(RequestGetPrtgConfigs, getPrtgConfigs),
  takeLatest(RequestSetPrtgConfigs, setPrtgConfigs),
  takeLatest(RequestGetUpdateSchedulerConfigs, getUpdateSchedulerConfigs),
  takeLatest(RequestSetUpdateSchedulerConfigs, setUpdateSchedulerConfigs),
  takeLatest(RequestGetLdapStatus, getLdapStatus),
  takeLatest(RequestGetLdapConfigs, getLdapConfigs),
  takeLatest(RequestSetLdapConfigs, setLdapConfigs),
  takeLatest(RequestToggleLdapStatus, toggleLdapStatus),
  takeLatest(RequestGetLlmSettings, getLlmSettings),
  takeLatest(RequestSetLlmSettings, setLlmSettings),
  takeLatest(RequestTestLlmSettings, testLlmSettings),
  takeLatest(RequestToggleLlmSettings, toggleLlmSettings),
  takeLatest(RequestCoreServers, coreServers),
  takeLatest(RequestUpdateCoreServers, updateCoreServers),
  takeLatest(requestGetAutoSubmissionSettings, getAutoSubmissionSettings),
  takeLatest(requestSetAutoSubmissionSettings, setAutoSubmissionSettings),
  takeLatest(requestResetAutoSubmissionSettings, resetAutoSubmissionSettings),
];

export default settingsSagas;
